import { useState } from 'react'

import { t } from '../../../../../../../common/i18n.js'
import type { Language } from '../../../../../../../common/types/i18n.js'
import { ChevronDown, ChevronUp } from '../../../../../../components/icon/solar-icons.js'
import { Section, SectionHeader } from '../../../../../../components/section/section.js'
import type { DaysTakenRow } from './time-away-derive.js'

interface TimeAwayDaysTakenCardProps {
    visible: DaysTakenRow[]
    collapsed: DaysTakenRow[]
    lang: Language
}

// Per-leave-type usage: "7.8 / 40 päeva" for allowance policies, plain
// "2 päeva" for unlimited ones. Zero-information rows hide behind "Veel N".
export const TimeAwayDaysTakenCard = ({ visible, collapsed, lang }: TimeAwayDaysTakenCardProps) => {
    const [showAll, setShowAll] = useState(false)
    const view = t.portal.timeOff.view
    const carryoverLabel = t.portal.timeOff.balance.carryover(lang).toLowerCase()
    const rows = showAll ? [...visible, ...collapsed] : visible

    return (
        <Section className="time-away__taken-card">
            <SectionHeader title={view.daysTakenTitle(lang)} />
            <div className="time-away__taken-list">
                {rows.map((row) => (
                    <div key={row.policyId} className="time-away__taken-row">
                        <span className="time-away__taken-emoji">{row.emoji}</span>
                        <span className="time-away__taken-name">
                            {row.leaveTypeName}
                            {row.carryover > 0 && (
                                <span className="time-away__taken-footnote">
                                    +{row.carryover} {carryoverLabel}
                                </span>
                            )}
                        </span>
                        <span className="time-away__taken-count">{row.label}</span>
                    </div>
                ))}
            </div>
            {collapsed.length > 0 && (
                <button
                    type="button"
                    className="time-away__expander"
                    onClick={() => setShowAll(!showAll)}
                >
                    {showAll ? view.showLess(lang) : view.showMore(collapsed.length)(lang)}
                    {showAll ? <ChevronUp size={14} /> : <ChevronDown size={14} />}
                </button>
            )}
        </Section>
    )
}
